import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "max-w-sm mx-auto mt-8" }
const _hoisted_4 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100" }
const _hoisted_5 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" An Error Occurred ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, " An unexpected error occurred. Please contact an administrator to continue. ")
], -1)
const _hoisted_8 = { class: "mt-8" }
const _hoisted_9 = { class: "w-full bg-gray-100 rounded p-4 shadow-inner text-xs text-gray-600" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "max-w-sm mx-auto text-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNavBar = _resolveComponent("TheNavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheNavBar),
    (_ctx.currentVendor)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ExclamationIcon, {
                    class: "h-6 w-6 text-red-600",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_DialogTitle, {
                    as: "h3",
                    class: "text-lg leading-6 font-medium text-gray-900"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("pre", _hoisted_9, _toDisplayString(_ctx.error), 1)
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Spinner, { class: "text-green-600 w-8 h-8 inline-block" })
            ])
          ]))
  ]))
}